<ul>
  <li
    *ngFor="let row of data | keyvalue"
    class="li"
  >{{ row.key }}：{{ row.value }}</li>
</ul>
